/**
 * CRA bakes REACT_APP_BASE_API_URL at build time. If the bundle still has http://
 * while the SPA is served over HTTPS (CloudFront), browsers block XHR as mixed content.
 * When the page is HTTPS and the configured API origin is http:// for a non-local host,
 * use https:// instead (same host/path).
 *
 * @param {string} [raw]
 * @returns {string}
 */
export function resolveApiBaseUrl(raw) {
  let base = (raw || "").trim().replace(/\/?$/, "");
  if (!base) {
    return "";
  }
  if (typeof window === "undefined") {
    return base;
  }
  if (window.location.protocol !== "https:") {
    return base;
  }
  if (!/^http:\/\//i.test(base)) {
    return base;
  }
  try {
    const u = new URL(base);
    const host = u.hostname.toLowerCase();
    if (host === "localhost" || host === "127.0.0.1" || host === "::1") {
      return base;
    }
  } catch {
    return base;
  }
  return base.replace(/^http:/i, "https:");
}

/**
 * Axios and manual `fetch(\`\${base}/api/...\`)` expect the **origin only** (scheme + host [+ :port]),
 * never a trailing `/api`. A value like `https://alb.../api` becomes `/api/api/health` and every route
 * returns 404 `{"detail":"Not Found"}`.
 *
 * @param {string} [raw]
 * @returns {string}
 */
export function normalizeExplorerApiBaseUrl(raw) {
  let base = resolveApiBaseUrl(raw);
  if (!base) {
    return "";
  }
  base = base.replace(/\/+$/, "");
  if (/\/api$/i.test(base)) {
    if (process.env.NODE_ENV === "development") {
      // eslint-disable-next-line no-console
      console.warn(
        "[api] REACT_APP_BASE_API_URL should be the API origin only (e.g. https://…elb.amazonaws.com), not …/api — stripping trailing /api."
      );
    }
    base = base.replace(/\/api$/i, "");
  }
  return base;
}
